module.exports = __webpack_public_path__ + "img/training-expert.f9deb8d7.png";